import { render, staticRenderFns } from "./BasicRatingLayout.vue?vue&type=template&id=4b179289&"
import script from "./BasicRatingLayout.vue?vue&type=script&lang=ts&"
export * from "./BasicRatingLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports